import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=c9155e82&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDelete.vue?vue&type=style&index=0&id=c9155e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9155e82",
  null
  
)

export default component.exports